import styled from 'styled-components';
import * as colors from 'components/common/colorConstants';

export const DatePickerWrapper = styled.div`
  margin-top: 15px;
  box-shadow: 0 20px 35px rgba(0, 0, 0, 0.09);
  font-family: 'Roboto', sans-serif;

  .rdtPicker {
    padding: 16px;
    width: 256px;
    font-size: 11px;
    font-weight: 500;

    .dow {
      color: ${colors.lightGray2};
    }

    .rdtCounter .rdtCount {
      font-size: 11px;
      height: 14px;
    }

    .rdtTimeToggle,
    .rdtBtn,
    .rdtCount {
      color: ${colors.black4};
    }

    .rdtBtn:hover {
      border-radius: 3px;
      background-color: ${colors.lightGray14};
    }

    thead tr:first-child th {
      border-radius: 3px;
    }

    th {
      font-weight: 500;
      border-bottom-color: ${colors.white};
    }

    thead tr:first-child th:hover,
    td.rdtMonth:hover,
    td.rdtYear:hover,
    td.rdtDay:hover,
    .rdtTimeToggle:hover {
      background-color: ${colors.lightGray14};
    }

    td {
      border-radius: 3px;

      &.rdtToday:before {
        border-bottom-color: ${colors.purple1};
      }

      &.rdtDay {
        color: ${colors.black4};

        &.rdtActive {
          color: ${colors.whiteText};
        }

        &.rdtOld,
        &.rdtNew {
          color: ${colors.lightGray2};
        }

        &.rdtDisabled {
          color: ${colors.darkGray1};
        }
      }

      &.rdtActive,
      &.rdtActive:hover {
        background-color: ${colors.purple1};
      }
    }

    .rdtDays {
      thead tr:last-child th::before {
        content: '';
        display: block;
        height: 8px;
      }

      th,
      td {
        height: 27px;
        line-height: 27px;
      }

      tbody::after {
        content: '';
        display: block;
        height: 14px;
      }

      tfoot {
        border-top: 1px solid ${colors.lightGray6};

        &::before {
          content: '';
          display: block;
          height: 16px;
        }
      }
    }

    .rdtTime {
      thead {
        border-bottom: 1px solid ${colors.lightGray6};
        &::after {
          content: '';
          display: block;
          height: 12px;
        }
      }

      tbody::before {
        content: '';
        display: block;
        height: 12px;
      }

      .rdtCounter {
        height: 94px;

        .rdtBtn {
          height: 40px;
        }
      }

      .rdtCounterSeparator {
        line-height: 94px;
      }
    }
  }

  .rdtSwitch {
    color: ${colors.black4};
  }
`;
